export enum VWOVariations {
  GO_TO_CART_FOOTER_BUTTON = 'goToCartFooterButton',
  URGENCY_TRIGGER = 'urgencyTrigger',
}
